import React from 'react';
import { Monitor, Moon, Palette, Sun } from 'lucide-react';
import { Tema, useTheme } from '../../context/ThemeContext';

const OPCIONES: { valor: Tema; label: string; Icon: React.FC<{ className?: string }> }[] = [
  { valor: 'claro',   label: 'Claro',   Icon: Sun },
  { valor: 'oscuro',  label: 'Oscuro',  Icon: Moon },
  { valor: 'sistema', label: 'Sistema', Icon: Monitor },
];

/** Claro, oscuro o el del sistema. Se guarda en este dispositivo. */
export const Apariencia: React.FC = () => {
  const { tema, setTema } = useTheme();

  return (
    <div className="border-t border-gray-100 dark:border-gray-700 pt-5">
      <div className="flex items-center gap-3 mb-3">
        <Palette className="w-5 h-5 text-gray-500 dark:text-gray-400 shrink-0" />
        <div>
          <h3 id="titulo-apariencia" className="text-sm font-semibold text-gray-700 dark:text-gray-300">Apariencia</h3>
          <p className="text-xs text-gray-400 dark:text-gray-500">
            Con «Sistema», cambia sola cuando el iPhone o el ordenador pasan a modo oscuro. Solo en este dispositivo.
          </p>
        </div>
      </div>
      <div role="radiogroup" aria-labelledby="titulo-apariencia"
        className="grid grid-cols-3 gap-1 p-1 rounded-xl bg-gray-100 dark:bg-gray-700">
        {OPCIONES.map(({ valor, label, Icon }) => (
          <button key={valor} role="radio" aria-checked={tema === valor} onClick={() => setTema(valor)}
            className={`flex items-center justify-center gap-1.5 min-h-[44px] rounded-lg text-sm font-semibold transition ${
              tema === valor
                ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow-sm'
                : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'}`}>
            <Icon className="w-4 h-4" /> {label}
          </button>
        ))}
      </div>
    </div>
  );
};
